export default {
  uploading: 'Subiendo',
  cancel: 'Cancelar',
  editTitle: 'Editar Modelo de Referencia',
  newTitle: 'Nuevo Modelo de Referencia',
  save: 'Guardar',
  create: 'Crear',
  modelCodename: 'Código del Modelo',
  json: 'JSON',
  downloadPkl: 'Descargar archivo PKL actual',
  choosePklFile: 'Elegir archivo PKL',
  pklRequired: 'El archivo PKL es obligatorio',
  codenameRequired: 'El código es obligatorio',
  codenameInvalid: 'El código solo puede contener caracteres alfanuméricos, "-" o "_"',
  codenameExists: 'El código ya existe',
  jsonRequired: 'El JSON es obligatorio',
  invalidJson: 'JSON inválido'
}
